var exports = {
  "dS": "RoleAppearance.module__colored___Mk0yQV",
  "D7": "RoleAppearance.module__gradient___Mk0yQV",
  "Kk": "RoleAppearance.module__icon___Mk0yQV",
};

module.exports = exports;
